export default {"src":"/_next/static/media/circleShield_24.44af6deb.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};